'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.submitLogin = exports.getUiLogin = exports.LOGIN_SUCCESS = exports.LOGIN_REQUEST = exports.LOGIN_FAIL = undefined;

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.default = reducer;

var _modal = require('../modules/modal');

var _api = require('../api');

var _reselect = require('reselect');

var _item = require('../modules/item');

var _config = require('../modules/config');

var _analytics = require('../modules/analytics');

var _saveItem = require('../modules/saveItem');

var _shouldLogin = require('../modules/shouldLogin');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* Action Types */
var LOGIN_FAIL = exports.LOGIN_FAIL = 'LOGIN_FAIL';
var LOGIN_REQUEST = exports.LOGIN_REQUEST = 'LOGIN_REQUEST';
var LOGIN_SUCCESS = exports.LOGIN_SUCCESS = 'LOGIN_SUCCESS';

/* reducer */
var DEFAULT_STATE = {
    error: false,
    errorMessage: '',
    submitted: false,
    success: false
};

function reducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_STATE;
    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    switch (action.type) {
        case LOGIN_FAIL:
            return (0, _extends3.default)({}, state, {
                error: true,
                errorMessage: action.payload.message,
                submitted: false,
                success: false
            });
        case LOGIN_REQUEST:
            return (0, _extends3.default)({}, state, {
                error: false,
                errorMessage: '',
                submitted: true,
                success: false
            });
        case LOGIN_SUCCESS:
            return (0, _extends3.default)({}, state, {
                submitted: false,
                success: true
            });
        case _modal.OPEN_LOGIN_MODAL:
        case _shouldLogin.OPEN_LOGIN_MODAL_FROM_CHECKER:
            return (0, _extends3.default)({}, state, {
                error: false,
                errorMessage: '',
                submitted: false,
                success: false
            });
        default:
            return state;
    }
}

/* SELECTORS */
var stateSelector = function stateSelector(state) {
    return state.ui.login;
};

var getUiLogin = exports.getUiLogin = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state;
});

/* ACTION CREATORS */
var loginFail = function loginFail(emailAddress, error) {
    return {
        error: true,
        meta: { emailAddress: emailAddress },
        payload: error,
        type: LOGIN_FAIL
    };
};

var loginRequest = function loginRequest(emailAddress) {
    return {
        payload: emailAddress,
        type: LOGIN_REQUEST
    };
};

var loginSuccess = function loginSuccess(loginData) {
    return {
        meta: (0, _extends3.default)({}, (0, _analytics.getLoginAnalytics)(loginData), { actionTime: Date.now() }),
        payload: loginData,
        type: LOGIN_SUCCESS
    };
};

var submitLogin = exports.submitLogin = function submitLogin(emailAddress, password) {
    var mainhostLogin = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

    return function (dispatch, getState) {
        var state = getState();
        var deployment = (0, _config.getDeployment)(state);
        var username = emailAddress || mainhostLogin.authNuid;
        dispatch(loginRequest(username));
        return _api.Bidder.postLogin({ deployment: deployment, mainhostLogin: mainhostLogin, password: password, username: username }).then(function (response) {
            dispatch((0, _modal.completeLoginModal)());
            return _promise2.default.all([dispatch(loginSuccess(response.data))]).then(function () {
                var state2 = getState();
                var savedItemIds = (0, _saveItem.getSortedSavedItemIdsFromState)(state2);
                return _promise2.default.all([dispatch((0, _item.fetchItemsIfNeeded)(savedItemIds))]);
            });
        }).catch(function (error) {
            dispatch(loginFail(emailAddress, error));
        });
    };
};


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/login.js
// module id = SpFG
// module chunks = 57